import { Injectable, OnDestroy } from '@angular/core';
import { Observable, Subscription, combineLatest } from 'rxjs';
import { filter, map, tap, withLatestFrom, take, switchMap } from 'rxjs/operators';
import { ResourceStringMap } from '../../models/models-index';
import { Store } from '@ngrx/store';
import { AppState } from '../../../_store/app-state.model';
import { AppSelectors } from '../../../_store/selector-types';
import { cultureCodes } from '../../constants/constants';

@Injectable()
export class SharedTranslationService implements OnDestroy {
  appSectionTranslations: any;
  navLabelTranslations: any;  
  resourceStringMap: ResourceStringMap;
  subscriptions: Subscription[] = [];

  constructor(
    private store$: Store<AppState>
  ) {
    this.subscriptions.push(this.store$.select(AppSelectors.selectConfigState).pipe(
      filter(config => !!config),
      map(config => {
        return config.resourceStrings;
      })
    ).subscribe(rs => {
      this.resourceStringMap = rs;
    }))
  }

  ngOnDestroy() {
    this.subscriptions.forEach(x => x.unsubscribe())
  }

  getLabelTranslation(value: string, locale?: string): string {
    locale = locale == 'en' ? cultureCodes.English : locale;  // Do we still need this?
    const key = value?.toLowerCase().replace(/[^A-Z0-9]+/ig, '');

    const result = this.resourceStringMap?.[locale]?.[key];

    //console.log(value, locale, '|', key, '|', v5result, v4result);

    return result || value || null;
  }
}

